export default __webpack_public_path__ + "static/media/LogoHeader.6f4bca1f.png";